export default __webpack_public_path__ + "static/media/worker.e18205b6.png";